// React submits to this Apps Script Web App, which forwards the data to the
// live HKI Studio Franchise Google Form's /formResponse endpoint. React never
// talks to Google Forms directly — see apps-script/franchise-form/Code.gs for
// the entry IDs and pageHistory values used on the Apps Script side.
export const FRANCHISE_FORM_ENDPOINT = process.env.REACT_APP_FRANCHISE_APPS_SCRIPT_URL;

export const STATES = ["Haryana / हरियाणा", "Uttar Pradesh / उत्तर प्रदेश"];

export const GENDERS = [
  ["Male", "पुरुष"],
  ["Female", "महिला"],
  ["Other", "अन्य"],
];

export const CATEGORIES = [
  ["General", "सामान्य"],
  ["OBC", "ओबीसी"],
  ["SC", "एससी"],
  ["ST", "एसटी"],
  ["EWS", "ईडब्ल्यूएस"],
];

export const SKILLS = [
  ["Social Media Management", "सोशल मीडिया मैनेजमेंट"],
  ["Digital Marketing", "डिजिटल मार्केटिंग"],
  ["Ads Management", "एड्स मैनेजमेंट"],
  ["Influencer Management", "इन्फ्लुएंसर मैनेजमेंट"],
  ["Graphic Designing", "ग्राफिक डिजाइनिंग"],
  ["Content Creation", "कंटेंट क्रिएशन"],
  ["Photography", "फोटोग्राफी"],
  ["Videography", "वीडियोग्राफी"],
  ["Video Editing", "वीडियो एडिटिंग"],
  ["Other", "अन्य"],
];

export const DECLARATION_VALUE =
  "I agree to the above declaration. / मैं उपरोक्त घोषणा से सहमत हूँ।";

export const DISTRICTS_BY_STATE = {
  "Haryana / हरियाणा": [
    ["Ambala", "अंबाला"],
    ["Bhiwani", "भिवानी"],
    ["Charkhi Dadri", "चरखी दादरी"],
    ["Faridabad", "फरीदाबाद"],
    ["Fatehabad", "फतेहाबाद"],
    ["Gurugram", "गुरुग्राम"],
    ["Hisar", "हिसार"],
    ["Jhajjar", "झज्जर"],
    ["Jind", "जींद"],
    ["Kaithal", "कैथल"],
    ["Karnal", "करनाल"],
    ["Kurukshetra", "कुरुक्षेत्र"],
    ["Mahendragarh", "महेंद्रगढ़"],
    ["Nuh", "नूंह"],
    ["Palwal", "पलवल"],
    ["Panchkula", "पंचकूला"],
    ["Panipat", "पानीपत"],
    ["Rewari", "रेवाड़ी"],
    ["Rohtak", "रोहतक"],
    ["Sirsa", "सिरसा"],
    ["Sonipat", "सोनीपत"],
    ["Yamunanagar", "यमुनानगर"],
  ],
  "Uttar Pradesh / उत्तर प्रदेश": [
    ["Agra", "आगरा"],
    ["Aligarh", "अलीगढ़"],
    ["Ambedkar Nagar", "अंबेडकर नगर"],
    ["Amethi", "अमेठी"],
    ["Amroha", "अमरोहा"],
    ["Auraiya", "औरैया"],
    ["Ayodhya", "अयोध्या"],
    ["Azamgarh", "आजमगढ़"],
    ["Baghpat", "बागपत"],
    ["Bahraich", "बहराइच"],
    ["Ballia", "बलिया"],
    ["Balrampur", "बलरामपुर"],
    ["Banda", "बांदा"],
    ["Barabanki", "बाराबंकी"],
    ["Bareilly", "बरेली"],
    ["Basti", "बस्ती"],
    ["Bhadohi", "भदोही"],
    ["Bijnor", "बिजनौर"],
    ["Budaun", "बदायूं"],
    ["Bulandshahr", "बुलंदशहर"],
    ["Chandauli", "चंदौली"],
    ["Chitrakoot", "चित्रकूट"],
    ["Deoria", "देवरिया"],
    ["Etah", "एटा"],
    ["Etawah", "इटावा"],
    ["Farrukhabad", "फर्रुखाबाद"],
    ["Fatehpur", "फतेहपुर"],
    ["Firozabad", "फिरोजाबाद"],
    ["Gautam Buddha Nagar", "गौतम बुद्ध नगर"],
    ["Ghaziabad", "गाजियाबाद"],
    ["Ghazipur", "गाजीपुर"],
    ["Gonda", "गोंडा"],
    ["Gorakhpur", "गोरखपुर"],
    ["Hamirpur", "हमीरपुर"],
    ["Hapur", "हापुड़"],
    ["Hardoi", "हरदोई"],
    ["Hathras", "हाथरस"],
    ["Jalaun", "जालौन"],
    ["Jaunpur", "जौनपुर"],
    ["Jhansi", "झांसी"],
    ["Kannauj", "कन्नौज"],
    ["Kanpur Dehat", "कानपुर देहात"],
    ["Kanpur Nagar", "कानपुर नगर"],
    ["Kasganj", "कासगंज"],
    ["Kaushambi", "कौशांबी"],
    ["Kushinagar", "कुशीनगर"],
    ["Lakhimpur Kheri", "लखीमपुर खीरी"],
    ["Lalitpur", "ललितपुर"],
    ["Lucknow", "लखनऊ"],
    ["Maharajganj", "महाराजगंज"],
    ["Mahoba", "महोबा"],
    ["Mainpuri", "मैनपुरी"],
    ["Mathura", "मथुरा"],
    ["Mau", "मऊ"],
    ["Meerut", "मेरठ"],
    ["Mirzapur", "मिर्जापुर"],
    ["Moradabad", "मुरादाबाद"],
    ["Muzaffarnagar", "मुजफ्फरनगर"],
    ["Pilibhit", "पीलीभीत"],
    ["Pratapgarh", "प्रतापगढ़"],
    ["Prayagraj", "प्रयागराज"],
    ["Raebareli", "रायबरेली"],
    ["Rampur", "रामपुर"],
    ["Saharanpur", "सहारनपुर"],
    ["Sambhal", "संभल"],
    ["Sant Kabir Nagar", "संत कबीर नगर"],
    ["Shahjahanpur", "शाहजहांपुर"],
    ["Shamli", "शामली"],
    ["Shravasti", "श्रावस्ती"],
    ["Siddharthnagar", "सिद्धार्थनगर"],
    ["Sitapur", "सीतापुर"],
    ["Sonbhadra", "सोनभद्र"],
    ["Sultanpur", "सुल्तानपुर"],
    ["Unnao", "उन्नाव"],
    ["Varanasi", "वाराणसी"],
  ],
};
